export const isBannerDateActual = (beginDate, finishDate) => {
  let result;

  const isDate = (date) => (date ? new Date(date) : null);

  const start = isDate(beginDate);
  const end = isDate(finishDate);
  const actualDate = new Date();

  if (start && end) {
    actualDate >= start && actualDate < end
      ? (result = true)
      : (result = false);
    return result;
  }

  if (start === null && end) {
    actualDate < end ? (result = true) : (result = false);
    return result;
  }

  if (start && end === null) {
    actualDate >= start ? (result = true) : (result = false);
    return result;
  }

  if (start === null && end === null) {
    return true;
  }
};
